import {Injectable}    from "@angular/core";
import {HttpClient}    from "@angular/common/http";
import {ConfigService} from "./config.service";
import Swal            from "sweetalert2";
import {Observable}    from "rxjs";
import {Router}        from "@angular/router";
import { LoadingService } from "./loading.service";

@Injectable({
    providedIn: "root"
})
export class APIService {

    constructor(
        private http: HttpClient,
        private config: ConfigService,
        private router: Router,
        private loadingService: LoadingService
    ) {}

    get(endpoint: string, query?: object, doNotHandleError?: boolean): Promise<any> {
        return this.request(endpoint, query, doNotHandleError, "GET");
    }

    post(endpoint: string, data: any, doNotHandleError?: boolean, ignoreLoading?: boolean): Promise<any> {
        return this.request(endpoint, data, doNotHandleError, "POST", ignoreLoading);
    }

    put(endpoint: string, data: any, doNotHandleError?: boolean): Promise<any> {
        return this.request(endpoint, data, doNotHandleError, "PUT");
    }

    delete(endpoint: string, data?: any, doNotHandleError?: boolean): Promise<any> {
        return this.request(endpoint, data, doNotHandleError, "DELETE");
    }

    private request(endpoint: string, data: any, doNotHandleError: boolean, method: string, ignoreLoading?: boolean) {
        if (!ignoreLoading) {
            this.loadingService.startLoading();
        }

        method = method.toLocaleLowerCase();
        if (!["get", "post", "put", "delete"].includes(method)) {
            throw new Error("Method not allowed by client");
        }

        if (endpoint.startsWith("/")) {
            const charlist = endpoint.split("");
            charlist.shift();
            endpoint = charlist.join("");
        }
        const url = ConfigService.getConfig("apiAddr") + endpoint;

        let req: Observable<any>;

        if (["post", "put", "patch"].includes(method)) {
            req = this.http[method](url, data, {withCredentials: true});
        } else {
            req = this.http[method](url, {params: data, withCredentials: true});
        }

        return req.toPromise()
            .then((response) => {
                if (!ignoreLoading) {
                    this.loadingService.stopLoading();
                }
                return response;
            })
                  .catch((error: any) => {
                      if (!doNotHandleError) {
                          if (error.status === 401) {
                              this.router.navigate(["/login"]);
                              localStorage.clear();
                              sessionStorage.clear();
                              this.loadingService.stopLoading();
                              return Swal.fire({
                                      title: "Atenção",
                                      text: "Sua sessão expirou, realize o login novamente!",
                                      icon: "warning"
                                  }).then( () => {
                                      location.reload();
                              });

                          } else {
                              Swal.fire({
                                  title: "Erro!",
                                  text:  error.msg || "Ocorreu um erro. F12 para detalhes",
                                  icon:  "error"
                              });
                              console.error(error);
                          }
                      }
                      if (!ignoreLoading) {
                          this.loadingService.stopLoading();
                      }
                      return Promise.reject(error);
                  });
    }
}
